import {
  VisaDocumentMutationInput,
  useCreateVisaDocument,
} from 'api-hooks/visa-document';
import { KIND, Notification } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import { PreviousNavigation } from 'common/helpers/previous-navigation';
import notification from 'components/common/notification';
import useGetCrudPermission from 'hooks/use-get-crud-permission';
import useNavigation from 'hooks/use-navigation';
import { SeparatorVertical } from 'legacy-modules/styles';
import React from 'react';
import { NavigationProps } from 'types';

import VisaDocumentForm from './components/visa-document-form';
import { VisaDocumentMethodType } from './components/visa-document-form-type';

export type VisaDocumentCreateParams = null;

export default function VisaDocumentCreate(
  props: NavigationProps<NavigationRoutes.VisaDocumentCreate>,
) {
  const { navigate, back } = useNavigation();
  const { mutateAsync, error } = useCreateVisaDocument();
  const permission = useGetCrudPermission('visa-documents');

  const onSubmit = React.useCallback(
    async (values: VisaDocumentMutationInput, form: VisaDocumentMethodType) => {
      const result = await mutateAsync(values);

      const prevPath = PreviousNavigation.get();
      if (prevPath) {
        PreviousNavigation.remove();
        back();
      } else if (permission.view) {
        navigate(NavigationRoutes.VisaDocumentView, {
          id: result.data.id,
        });
      }

      notification.success({ message: result?.message });
      return result.data;
    },
    [back, mutateAsync, navigate, permission.view],
  );

  return (
    <VisaDocumentForm
      onSubmit={onSubmit}
      renderError={
        !!error &&
        !!error.message && (
          <>
            <Notification
              overrides={{
                Body: { style: { width: 'auto', wordBreak: 'break-all' } },
              }}
              kind={KIND.negative}
              closeable
            >
              {() => error.message}
            </Notification>
            <SeparatorVertical $margin={8} />
          </>
        )
      }
    />
  );
}
